import { useTranslation, TranslationPhrase } from '@/services/translation';

export function useLocalizedTexts() {
  const { t } = useTranslation();
  const localizedTextsDictionary = {
    ohSorryGotSomeTroublesText:               t(TranslationPhrase.ERROR_BOUNDARY_TITLE),
    pleaseReloadThePageText:                  t(TranslationPhrase.ERROR_BOUNDARY_WARNING_PART_1),
    ifThisDoesNotHelpPleaseClearTheCacheText: t(TranslationPhrase.ERROR_BOUNDARY_WARNING_PART_2),
    howToCleanCacheText:                      t(TranslationPhrase.ERROR_BOUNDARY_CLEAR_CACHE_BUTTON),
  };
  return localizedTextsDictionary;
}
